import request from "./API";

export const UpdateProfile = (data) => {
  return request.post("/admin-form/profile/change", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
